var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[(_vm.items)?_c('v-breadcrumbs',{attrs:{"items":_vm.items}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }